import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-cream-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <Logo size="md" />
              <div className="flex flex-col">
                <span className="font-serif text-2xl tracking-tight leading-none">Unya Mee</span>
                <span className="text-xs uppercase tracking-widest text-warm-gray">Upcycling Practice</span>
              </div>
            </div>
            <p className="text-warm-gray text-sm leading-relaxed">
              {t('footerTagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              <Link to="/" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                {t('home')}
              </Link>
              <Link to="/workshops" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                {t('workshops')}
              </Link>
              <Link to="/shop" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                {t('shop')}
              </Link>
              <Link to="/about" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                {t('about')}
              </Link>
              <Link to="/contact" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                {t('contact')}
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg">{t('contactInfo')}</h3>
            <div className="space-y-3">
              <a href="mailto:jm.michalczak@gmail.com" className="flex items-center space-x-3 text-warm-gray hover:text-warm-sage transition-colors text-sm">
                <Mail size={18} />
                <span>jm.michalczak@gmail.com</span>
              </a>
              <a href="tel:+48604436886" className="flex items-center space-x-3 text-warm-gray hover:text-warm-sage transition-colors text-sm">
                <Phone size={18} />
                <span>+48 604 436 886</span>
              </a>
              <a href="https://www.instagram.com/unya_mee/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-warm-gray hover:text-warm-sage transition-colors text-sm">
                <Instagram size={18} />
                <span>@unya_mee</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-warm-gray/20 mt-12 pt-8">
          <div className="text-center space-y-3">
            <p className="text-warm-gray text-sm">
              © {currentYear} Unya Mee. {t('footerRights')}.
            </p>
            <div className="flex items-center justify-center space-x-2 text-xs">
              <span className="text-warm-gray/60">Crafted with</span>
              <span className="text-warm-sage animate-pulse">♻️</span>
              <span className="text-warm-gray/60">by</span>
              <a
                href="https://rayenlazizi.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center space-x-1 text-warm-sage hover:text-cream-white transition-all duration-300"
              >
                <span className="font-medium tracking-wide">Rayen Lazizi</span>
                <svg
                  className="w-3 h-3 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-warm-sage group-hover:w-full transition-all duration-300"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;